<template>
    <div :class="`hour hour-align-${localAlign}`">
        <label for="hour" @click="focusFieldLabel" v-if="!editingFieldLabel">{{ displayFieldLabel }}</label>
            <input
            v-if="editingFieldLabel"
                type="text"
            class="field-label-input"
            placeholder="Saat"
                v-model="localFieldLabel"
            @blur="stopEditingFieldLabel"
            @keydown.enter="stopEditingFieldLabel"
            ref="fieldLabelInput"
            />
        <div class="input-wrapper-two">
                <div class="time-input">
                <div class="input-container">
                    <input
                        type="text"
                        id="time"
                        name="time"
                        placeholder="HH : MM"
                        v-model="timeValue"
                        @input="updateField"
                        @focus="onFocus"
                        @blur="onBlur"
                        maxlength="5"
                    />
                    <div class="input-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="10"/>
                            <polyline points="12,6 12,12 16,14"/>
                        </svg>
                    </div>
                </div>
                <label for="time">{{ hourLabel || 'Saat' }}</label>
            </div>
            <div class="ampm-input">
                <div class="select-container">
                    <select
                        id="ampm"
                        name="ampm"
                        v-model="ampmValue"
                        @change="updateField"
                        @focus="onFocus"
                        @blur="onBlur"
                    >
                        <option value="AM">ÖÖ</option>
                        <option value="PM">ÖS</option>
                    </select>
                    <div class="select-arrow">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="6,9 12,15 18,9"/>
                        </svg>
                </div>
                </div>
                <label for="ampm">{{ minuteLabel || 'Dakika' }}</label>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "FormHour",
    props: {
        fieldLabel: String,
        align: String,
        hourLabel: String,
        minuteLabel: String,
        item: Object,
        isRequired: Boolean,
    },
    data() {
        return {
            localFieldLabel: this.fieldLabel || "",
            localAlign: this.align || "top",
            timeValue: "",
            ampmValue: "AM",
            editingFieldLabel: false,
            updateTimer: null,
        };
    },
    computed: {
        displayFieldLabel() {
            return this.localFieldLabel || "Saat";
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        focusFieldLabel() {
            this.editingFieldLabel = true;
            this.$nextTick(() => {
                if (this.$refs.fieldLabelInput) {
                    this.$refs.fieldLabelInput.focus();
                }
            });
        },
        stopEditingFieldLabel() {
            this.editingFieldLabel = false;
            this.updateField();
        },
        onFocus() {
            // Focus handling
        },
        onBlur() {
            // Blur handling
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
            const updateFields = {
                hour: {
                        fieldLabel: self.localFieldLabel,
                        time: self.timeValue,
                        period: self.ampmValue,
                        align: self.localAlign,
                        hourLabel: self.hourLabel,
                        minuteLabel: self.minuteLabel,
                        isRequired: self.isRequired,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                updateFields: updateFields,
            });
                self.$emit("update-field", updateFields);
            }, 200);
        },
    },
    watch: {
        fieldLabel(newVal) {
            this.localFieldLabel = newVal;
        },
        align(newVal) {
            this.localAlign = newVal;
        },
        'item.hour.fieldLabel': function (v) { this.localFieldLabel = v; },
        'item.hour.hourLabel': function (v) {
            // Hour label değişikliklerini takip et
        },
        'item.hour.minuteLabel': function (v) {
            // Minute label değişikliklerini takip et
        },
    },
};
</script>

<style lang="scss" scoped>
.hour {
    width: 100%;
    max-width: 700px;
    margin: clamp(0.5rem, 1.5vw, 1rem) auto;
    padding: clamp(0.625rem, 1.5vw, 0.875rem);
    background: linear-gradient(145deg,
        rgba(255, 255, 255, 0.02) 0%,
        rgba(255, 255, 255, 0.01) 100%);
    border-radius: 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.06);
    transition: all 0.3s ease;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

    &:hover {
        background: linear-gradient(145deg,
            rgba(255, 255, 255, 0.03) 0%,
            rgba(255, 255, 255, 0.02) 100%);
    }

    > label {
        display: block;
        font-size: clamp(0.95rem, 2.2vw, 1.1rem);
        font-weight: 600;
        margin: 0 0 clamp(0.5rem, 1.2vw, 0.75rem) 0;
        color: rgba(55, 65, 81, 0.9);
        line-height: 1.4;
        cursor: pointer;
    }

    .field-label-input {
        font-size: clamp(0.95rem, 2.2vw, 1.1rem);
        font-weight: 600;
        margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        color: rgba(55, 65, 81, 0.9);
        line-height: 1.4;
        border: none;
        background: transparent;
        outline: none;
        border-bottom: 2px solid #f26a52;
        padding: 0 0 2px 0;

        &::placeholder {
            color: rgba(156, 163, 175, 0.7);
        }
    }

    .input-wrapper-two {
        display: flex;
        gap: clamp(0.75rem, 2vw, 1rem);
        position: relative;
    }

    .time-input,
    .ampm-input {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: clamp(0.375rem, 1vw, 0.5rem);

        label {
            font-size: clamp(0.8rem, 1.8vw, 0.875rem);
            color: rgba(107, 114, 128, 0.8);
            font-weight: 500;
            text-align: center;
            line-height: 1.3;
        }
    }

    .input-container {
        position: relative;
        background: rgba(255, 255, 255, 0.8);
        backdrop-filter: blur(8px);
        border: 2px solid rgba(209, 213, 219, 0.6);
        border-radius: clamp(0.5rem, 1.5vw, 0.75rem);
        transition: all 0.3s ease;

        &:hover {
            border-color: #f26a52;
            box-shadow: 0 4px 12px rgba(242, 106, 82, 0.15);
        }

        &:focus-within {
            border-color: #f26a52;
            box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
        }

        input {
            width: 100%;
            padding: clamp(0.75rem, 2vw, 1rem) clamp(2.5rem, 6vw, 3.125rem) clamp(0.75rem, 2vw, 1rem) clamp(0.75rem, 2vw, 1rem);
            font-size: clamp(0.875rem, 2vw, 1rem);
            font-weight: 500;
            color: rgba(55, 65, 81, 0.9);
            background: transparent;
            border: none;
            outline: none;
            text-align: center;
            font-family: inherit;
            letter-spacing: 0.5px;

            &::placeholder {
                color: rgba(107, 114, 128, 0.7);
                font-weight: 400;
                letter-spacing: 1px;
            }
        }

        .input-icon {
            position: absolute;
            right: clamp(0.75rem, 2vw, 1rem);
            top: 50%;
            transform: translateY(-50%);
            width: clamp(1rem, 2.5vw, 1.25rem);
            height: clamp(1rem, 2.5vw, 1.25rem);
            color: rgba(107, 114, 128, 0.7);
            transition: all 0.3s ease;

            svg {
                width: 100%;
                height: 100%;
            }
        }

        &:focus-within .input-icon {
            color: #f26a52;
            transform: translateY(-50%) scale(1.1);
        }
    }

    .select-container {
        position: relative;
        background: rgba(255, 255, 255, 0.8);
        backdrop-filter: blur(8px);
        border: 2px solid rgba(209, 213, 219, 0.6);
        border-radius: clamp(0.5rem, 1.5vw, 0.75rem);
        transition: all 0.3s ease;

        &:hover {
            border-color: #f26a52;
            box-shadow: 0 4px 12px rgba(242, 106, 82, 0.15);
        }

        &:focus-within {
            border-color: #f26a52;
            box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
            }

            select {
            width: 100%;
            padding: clamp(0.75rem, 2vw, 1rem) clamp(2.5rem, 6vw, 3.125rem) clamp(0.75rem, 2vw, 1rem) clamp(0.75rem, 2vw, 1rem);
            font-size: clamp(0.875rem, 2vw, 1rem);
            font-weight: 500;
            color: rgba(55, 65, 81, 0.9);
            background: transparent;
            border: none;
            outline: none;
            text-align: center;
            font-family: inherit;
                appearance: none;
            cursor: pointer;

            option {
                background: rgba(255, 255, 255, 0.95);
                color: rgba(55, 65, 81, 0.9);
                padding: 8px;
            }
        }

        .select-arrow {
            position: absolute;
            right: clamp(0.75rem, 2vw, 1rem);
            top: 50%;
            transform: translateY(-50%);
            width: clamp(0.875rem, 2.2vw, 1.125rem);
            height: clamp(0.875rem, 2.2vw, 1.125rem);
            color: rgba(107, 114, 128, 0.7);
            transition: all 0.3s ease;
            pointer-events: none;

            svg {
                width: 100%;
                height: 100%;
            }
        }

        &:focus-within .select-arrow {
            color: #f26a52;
            transform: translateY(-50%) rotate(180deg);
        }
    }

    .ampm-input {
        flex: 0.7;
    }

    .time-input {
        flex: 1.3;
    }
}

/* Alignment Classes */
.hour-align-left {
    display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);

    > label, .field-label-input {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: left;
    }

    .input-wrapper-two {
        flex: 1;
        min-width: 0;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0;

        > label, .field-label-input {
            width: 100%;
            text-align: left;
            padding-top: 0;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        }

        .input-wrapper-two {
            width: 100%;
        }
    }
}

.hour-align-right {
            display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);

    > label, .field-label-input {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: right;
    }

    .input-wrapper-two {
        flex: 1;
        min-width: 0;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0;

        > label, .field-label-input {
            width: 100%;
            text-align: left;
            padding-top: 0;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        }

        .input-wrapper-two {
            width: 100%;
        }
    }
}

.hour-align-top {
    > label {
        text-align: left;
    }
}

@media (max-width: 768px) {
    .hour {
        margin: clamp(0.25rem, 1vw, 0.5rem) auto;
        padding: clamp(0.5rem, 1.2vw, 0.75rem);

        .input-wrapper-two {
            gap: clamp(0.375rem, 1vw, 0.5rem);
        }

        .input-container,
        .select-container {
            border-radius: clamp(0.375rem, 1vw, 0.5rem);

            input,
            select {
                padding: clamp(0.625rem, 1.5vw, 0.75rem) clamp(2.25rem, 5vw, 2.75rem) clamp(0.625rem, 1.5vw, 0.75rem) clamp(0.625rem, 1.5vw, 0.75rem);
                font-size: clamp(0.8rem, 1.8vw, 0.875rem);
            }

            .input-icon,
            .select-arrow {
                right: clamp(0.625rem, 1.5vw, 0.75rem);
                width: clamp(0.875rem, 2.2vw, 1.125rem);
                height: clamp(0.875rem, 2.2vw, 1.125rem);
            }
        }

        .time-input label,
        .ampm-input label {
            font-size: clamp(0.75rem, 1.6vw, 0.8rem);
        }
    }
}

@media (prefers-reduced-motion: reduce) {
    .hour, .input-container, .select-container, .input-icon, .select-arrow {
        transition: none;
    }

    .input-container:hover, .select-container:hover {
        transform: none;
    }

    .input-container:focus-within .input-icon, .select-container:focus-within .select-arrow {
        transform: translateY(-50%);
    }
}
</style>
